export default __webpack_public_path__ + "static/Natural-e11c2acee1c6c3b301ff6ffa8664b462.jpg";